import politeAlertAudioUrl from './assets/polite_alert.mp3'

export interface AudioService {
  playNotificationAlert: () => unknown
}

export const playAudioNotificationAlert = () => {
  const audio = new Audio(politeAlertAudioUrl)
  audio.play()
}

export const openFinAudioService = {
  playNotificationAlert: playAudioNotificationAlert
}

export const browserAudioService = {
  playNotificationAlert: () => null
}
